/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateProjectdossierTemplateDto } from '../models/work-create-projectdossier-template-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkProjectdossierDocumentselectionOptionsDto } from '../models/work-projectdossier-documentselection-options-dto';
import { WorkProjectdossierTemplate } from '../models/work-projectdossier-template';
import { WorkUpdateProjectdossierTemplateDto } from '../models/work-update-projectdossier-template-dto';
import { WorkUpdateSortOrderProjectdossierTemplatesDto } from '../models/work-update-sort-order-projectdossier-templates-dto';

@Injectable({ providedIn: 'root' })
export class WorkProjectdossierTemplatesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectdossierTemplatesV2ControllerGetDocumentselectionOptions()` */
  static readonly ProjectdossierTemplatesV2ControllerGetDocumentselectionOptionsPath = '/v2/projectdossier-templates/documentselection-options/{containertypeId}';

  /**
   * Required permissions: projectdossier-templates:read, projectdossier-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossierTemplatesV2ControllerGetDocumentselectionOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossierTemplatesV2ControllerGetDocumentselectionOptions$Response(
    params: {
      containertypeId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProjectdossierDocumentselectionOptionsDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossierTemplatesV2Service.ProjectdossierTemplatesV2ControllerGetDocumentselectionOptionsPath, 'get');
    if (params) {
      rb.path('containertypeId', params.containertypeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProjectdossierDocumentselectionOptionsDto>>;
      })
    );
  }

  /**
   * Required permissions: projectdossier-templates:read, projectdossier-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossierTemplatesV2ControllerGetDocumentselectionOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossierTemplatesV2ControllerGetDocumentselectionOptions(
    params: {
      containertypeId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkProjectdossierDocumentselectionOptionsDto>> {
    return this.projectdossierTemplatesV2ControllerGetDocumentselectionOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProjectdossierDocumentselectionOptionsDto>>): Array<WorkProjectdossierDocumentselectionOptionsDto> => r.body)
    );
  }

  /** Path part for operation `projectdossierTemplatesV2ControllerGetDropdownOptions()` */
  static readonly ProjectdossierTemplatesV2ControllerGetDropdownOptionsPath = '/v2/projectdossier-templates/dropdown-options/{containertypeId}';

  /**
   * Required permissions: projectdossier-templates:read, projectdossier-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossierTemplatesV2ControllerGetDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossierTemplatesV2ControllerGetDropdownOptions$Response(
    params: {
      containertypeId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossierTemplatesV2Service.ProjectdossierTemplatesV2ControllerGetDropdownOptionsPath, 'get');
    if (params) {
      rb.path('containertypeId', params.containertypeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: projectdossier-templates:read, projectdossier-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossierTemplatesV2ControllerGetDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossierTemplatesV2ControllerGetDropdownOptions(
    params: {
      containertypeId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.projectdossierTemplatesV2ControllerGetDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `projectdossierTemplatesV2ControllerGetEnumSource()` */
  static readonly ProjectdossierTemplatesV2ControllerGetEnumSourcePath = '/v2/projectdossier-templates/enum-source/{source}';

  /**
   * Required permissions: projectdossier-templates:read, projectdossier-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossierTemplatesV2ControllerGetEnumSource()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossierTemplatesV2ControllerGetEnumSource$Response(
    params: {
      source: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossierTemplatesV2Service.ProjectdossierTemplatesV2ControllerGetEnumSourcePath, 'get');
    if (params) {
      rb.path('source', params.source, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: projectdossier-templates:read, projectdossier-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossierTemplatesV2ControllerGetEnumSource$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossierTemplatesV2ControllerGetEnumSource(
    params: {
      source: string;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.projectdossierTemplatesV2ControllerGetEnumSource$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectdossierTemplatesV2ControllerFindAllPaginated()` */
  static readonly ProjectdossierTemplatesV2ControllerFindAllPaginatedPath = '/v2/projectdossier-templates';

  /**
   * Required permissions: projectdossier-templates:read, projectdossier-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossierTemplatesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossierTemplatesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 500
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.containertypeId=$not:$like:John Doe&filter.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.containertypeId'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> containertypeId:ASC,sortOrder:ASC,name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>name</li>
     * <li>containertypeId</li>
     * <li>sortOrder</li>
     * <li>active</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'name:ASC' | 'name:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC' | 'sortOrder:ASC' | 'sortOrder:DESC' | 'active:ASC' | 'active:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkProjectdossierTemplate>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'containertypeId'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossierTemplatesV2Service.ProjectdossierTemplatesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.containertypeId', params['filter.containertypeId'], {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkProjectdossierTemplate>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'containertypeId'?: (string | Array<string>);
        'active'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: projectdossier-templates:read, projectdossier-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossierTemplatesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossierTemplatesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 500
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.containertypeId=$not:$like:John Doe&filter.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.containertypeId'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> containertypeId:ASC,sortOrder:ASC,name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>name</li>
     * <li>containertypeId</li>
     * <li>sortOrder</li>
     * <li>active</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'name:ASC' | 'name:DESC' | 'containertypeId:ASC' | 'containertypeId:DESC' | 'sortOrder:ASC' | 'sortOrder:DESC' | 'active:ASC' | 'active:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkProjectdossierTemplate>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'containertypeId'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
}> {
    return this.projectdossierTemplatesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkProjectdossierTemplate>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'containertypeId'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkProjectdossierTemplate>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'containertypeId'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `projectdossierTemplatesV2ControllerCreate()` */
  static readonly ProjectdossierTemplatesV2ControllerCreatePath = '/v2/projectdossier-templates';

  /**
   * Required permissions: projectdossier-templates:create, projectdossier-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossierTemplatesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectdossierTemplatesV2ControllerCreate$Response(
    params: {
      body: WorkCreateProjectdossierTemplateDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectdossierTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossierTemplatesV2Service.ProjectdossierTemplatesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectdossierTemplate>;
      })
    );
  }

  /**
   * Required permissions: projectdossier-templates:create, projectdossier-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossierTemplatesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectdossierTemplatesV2ControllerCreate(
    params: {
      body: WorkCreateProjectdossierTemplateDto
    },
    context?: HttpContext
  ): Observable<WorkProjectdossierTemplate> {
    return this.projectdossierTemplatesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectdossierTemplate>): WorkProjectdossierTemplate => r.body)
    );
  }

  /** Path part for operation `projectdossierTemplatesV2ControllerFindOneById()` */
  static readonly ProjectdossierTemplatesV2ControllerFindOneByIdPath = '/v2/projectdossier-templates/{id}';

  /**
   * Required permissions: projectdossier-templates:read, projectdossier-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossierTemplatesV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossierTemplatesV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectdossierTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossierTemplatesV2Service.ProjectdossierTemplatesV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectdossierTemplate>;
      })
    );
  }

  /**
   * Required permissions: projectdossier-templates:read, projectdossier-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossierTemplatesV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossierTemplatesV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectdossierTemplate> {
    return this.projectdossierTemplatesV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectdossierTemplate>): WorkProjectdossierTemplate => r.body)
    );
  }

  /** Path part for operation `projectdossierTemplatesV2ControllerDelete()` */
  static readonly ProjectdossierTemplatesV2ControllerDeletePath = '/v2/projectdossier-templates/{id}';

  /**
   * Required permissions: projectdossier-templates:delete, projectdossier-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossierTemplatesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossierTemplatesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossierTemplatesV2Service.ProjectdossierTemplatesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: projectdossier-templates:delete, projectdossier-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossierTemplatesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectdossierTemplatesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.projectdossierTemplatesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `projectdossierTemplatesV2ControllerUpdate()` */
  static readonly ProjectdossierTemplatesV2ControllerUpdatePath = '/v2/projectdossier-templates/{id}';

  /**
   * Required permissions: projectdossier-templates:update, projectdossier-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossierTemplatesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectdossierTemplatesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateProjectdossierTemplateDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectdossierTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossierTemplatesV2Service.ProjectdossierTemplatesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectdossierTemplate>;
      })
    );
  }

  /**
   * Required permissions: projectdossier-templates:update, projectdossier-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossierTemplatesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectdossierTemplatesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateProjectdossierTemplateDto
    },
    context?: HttpContext
  ): Observable<WorkProjectdossierTemplate> {
    return this.projectdossierTemplatesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectdossierTemplate>): WorkProjectdossierTemplate => r.body)
    );
  }

  /** Path part for operation `projectdossierTemplatesV2ControllerUpdateSortOrder()` */
  static readonly ProjectdossierTemplatesV2ControllerUpdateSortOrderPath = '/v2/projectdossier-templates/sort-order';

  /**
   * Required permissions: projectdossier-templates:update, projectdossier-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectdossierTemplatesV2ControllerUpdateSortOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectdossierTemplatesV2ControllerUpdateSortOrder$Response(
    params: {
      body: WorkUpdateSortOrderProjectdossierTemplatesDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProjectdossierTemplate>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectdossierTemplatesV2Service.ProjectdossierTemplatesV2ControllerUpdateSortOrderPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProjectdossierTemplate>>;
      })
    );
  }

  /**
   * Required permissions: projectdossier-templates:update, projectdossier-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectdossierTemplatesV2ControllerUpdateSortOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectdossierTemplatesV2ControllerUpdateSortOrder(
    params: {
      body: WorkUpdateSortOrderProjectdossierTemplatesDto
    },
    context?: HttpContext
  ): Observable<Array<WorkProjectdossierTemplate>> {
    return this.projectdossierTemplatesV2ControllerUpdateSortOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProjectdossierTemplate>>): Array<WorkProjectdossierTemplate> => r.body)
    );
  }

}
